import { BatchClassConfig } from "../models/config/BatchClassConfig";
import { BatchClassMetadataData } from "../models/config/BatchClassMetadata";

type FragmentPassingInfo = {
  batchClassId?: string;
  batchInstanceId?: string;
  docId?: string;
};
class UrlStateClass {
  /**
   *
   * @param hash URL-Encoded URL Fragment
   */
  deconstructUrlFragment(hash: string) {
    if (hash == null || hash === "") return [];
    const decodedHash = decodeURIComponent(hash);
    const groups = decodedHash.split("/");
    if (groups == null || (Array.isArray(groups) && groups.length === 0))
      return [];

    return [groups[1], groups[2], groups[3]].filter((x) => x != null);
  }

  updateUrlFragments(data: FragmentPassingInfo | null): void {
    console.log("updatedURLFragments", data);
    let bcIdEmpty = false,
      biIdEmpty = false,
      docIdEmpty = false;

    if (data?.batchClassId == null || data.batchClassId.trim() === "")
      bcIdEmpty = true;
    if (data?.batchInstanceId == null || data.batchInstanceId.trim() === "")
      biIdEmpty = true;
    if (data?.docId == null || data.docId.trim() === "") docIdEmpty = true;

    if (!bcIdEmpty && !biIdEmpty && !docIdEmpty) {
      // set bcc id and modelName
      window.location.hash = `#/${data!.batchClassId}/${
        data!.batchInstanceId
      }/${data!.docId}`;
    } else if (!bcIdEmpty && !biIdEmpty) {
      // set just bcc id
      window.location.hash = `#/${data!.batchClassId}/${data!.batchInstanceId}`;
    } else if (!bcIdEmpty) {
      window.location.hash = `#/${data!.batchClassId}`;
    } else {
      window.location.hash = "#";
    }
  }

  updateBcc(
    batchClassConfig: BatchClassMetadataData | BatchClassConfig | undefined,
  ) {
    this.updateUrlFragments({
      batchClassId: batchClassConfig?.batchClassId,
    });
  }

  filterBccs<T extends BatchClassConfig | BatchClassMetadataData>(
    batchClassConfigs: Array<T>,
  ): T | undefined {
    const groups = this.deconstructUrlFragment(window.location.hash);
    if (groups.length === 0) return undefined;
    const bccId = groups[0];
    return batchClassConfigs.find((bcc) => bcc.batchClassId === bccId);
  }

  subscribeToHashChanges(callback: () => void) {
    window.addEventListener("hashchange", callback);
    return () => {
      window.removeEventListener("hashchange", callback);
    };
  }

  addOnCloseHandler(callback: (e: BeforeUnloadEvent) => void) {
    window.addEventListener("beforeunload", callback);
  }
}

const UrlState = new UrlStateClass();
export { UrlState };
